"use client";
import Link from "next/link";
import { ArrowRight, DollarSign, Heart, BookOpen, Globe } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { benefits as data } from "@/lib/data/careers";

const accent = "var(--color-purple)";
const groups = [
  { title: "Compensation", icon: DollarSign, items: data.compensation },
  { title: "Health & Wellness", icon: Heart, items: data.health },
  { title: "Professional Development", icon: BookOpen, items: data.professional },
  { title: "Work Flexibility", icon: Globe, items: data.flexibility },
];

export function Benefits() {
  return (
    <Section id="benefits--compensation" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {groups.map((group, gi) => {
            const Icon = group.icon;
            return (
              <Reveal key={group.title} delay={gi * 100}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <div className="flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                      <Icon className="h-5 w-5" style={{ color: accent }} />
                    </span>
                    <h3 className="text-lg">{group.title}</h3>
                  </div>
                  <div className="mt-5 space-y-2">
                    {group.items.map((item, i) => (
                      <div key={i} className="flex items-baseline gap-2 text-sm">
                        <span className="eyebrow-tiny" style={{ color: accent }}>{"component" in item || "benefit" in item ? "" : "•"}</span>
                        <div>
                          <span className="font-semibold">{"component" in item ? item.component : "benefit" in item ? item.benefit : ""}</span>
                          <span className="text-[rgb(var(--fg-muted))]"> — {"details" in item ? item.details : "coverage" in item ? item.coverage : ""}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
